import { AfterViewInit, Directive, ElementRef, ViewChild } from '@angular/core';

@Directive({
    selector: '[elementFocus]',
    standalone: false
})
export class ElementFocusDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.el.nativeElement.focus();
  }

}